<template>
  <div>
    <b-modal
      v-model="showModal"
      title="Төлөв солих"
      scrollable
      no-fade
      centered
      size="sm"
      hide-footer
      @hide="cancel()"
    >
      <!-- <Modal :transition-names="[]" v-model="showModal" footer-hide title="Төлөв солих" @on-cancel="cancel"> -->
      <Form :model="passModel" :label-width="160">
        <FormItem label="Сонгох" class="m-b-sm">
          <Select placeholder="сонгоно уу" v-model="userState" clearable>
            <Option :value="1" label="Системийн">Системийн</Option>
            <Option :value="6" label="Системийн бус">Системийн бус</Option>
          </Select>
        </FormItem>
        <FormItem class="text-right pd-t-20">
          <Button
            size="large"
            @click="changeFlag()"
            type="primary"
            icon="ios-checkmark"
            >Хадгалах</Button
          >
        </FormItem>
      </Form>
      <!-- </Modal> -->
    </b-modal>
  </div>
</template>

<script>
//import { changeUserFlag } from "@/api/hr";
import "element-ui/lib/theme-chalk/index.css";
import { Form, FormItem, Button, Select, Option } from "element-ui";
import { request } from "@/api/all";
export default {
  name: "mdlUserStateChangeComp",
  components: {
    Form,
    FormItem,
    Select,
    Button,
    Option,
  },
  props: {
    taskId: {
      type: Number,
      default: () => null,
    },
    json: {
      type: Object,
      default: () => null,
    },
    isShow: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      passModel: {
        taskId: 0,
        locTypeId4: 0,
        new: "",
        userId: "",
      },
      userState: null,
      showModal: false
    };
  },
//   computed: {
//     showModal: {
//       get: function () {
//         this.passModel = this.json;
//         return this.isShow;
//       },
//       set: function () {},
//     },
//   },
 watch: {
    isShow(newVal) {
      if (newVal) {
        //console.log("nee")
        this.passModel = this.json;
        this.showModal = true;
        //this.init();
      }
    }
  },
  mounted() {},
  methods: {
    changeFlag() {
      let errs = [];

      if (this.userState == 0) {
        errs.push("Төлөв сонгоно уу !");
      }

      if (errs.length == 0) {
        // changeUserFlag({

        // })
        request({
          api: { method: "post", url: "HR/ChangeUserFlag" },
          data: {
            userId: this.passModel.userId,
            flag: this.userState,
          },
          store: self.$store,
        }).then((res) => {
          if (res != false) {
            // this.$Notice.success({
            //   title: "Амжилттай",
            //   desc: res.msg,
            // });
            this.$bvToast.toast("Амжилттай", {
              title: "Мэдэгдэл",
              autoHideDelay: 3000,
              appendToast: true
            });


            this.userState = 0;
            this.passModel.userId = "";

            this.cancel();
          }
        });
      } else {
        for (var i = 0; i < errs.length; i++) {
             this.$bvToast.toast(errs[i], {
            title: "Мэдэгдэл",
            autoHideDelay: 3000,
            appendToast: true
          });
          //   this.$Notice.warning({
          //     title: "Мэдэгдэл",
          //     desc: errs[i]
          //   });
        }
      }
    },
    cancel() {
        this.showModal = false;
      this.$emit("on-close");
    },
  },
};
</script>
